module.exports = {"resourceQuery":null,"query":"?query","prev":"test content"}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/query/loaders/queryloader.js?query!./loaders/query/context-query-test/test.js
 ** module id = 6
 ** module chunks = 0
 **/